import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { HelpCircleIcon } from 'lucide-react';
export function FAQ() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const faqs = [{
    question: '¿Tengo que saber mucho de tecnología?',
    answer: 'No, la guía explica todo en términos simples y claros.'
  }, {
    question: '¿Funciona si mi hijo ya no me habla?',
    answer: 'Sí, incluye estrategias específicas para romper el hielo sin presionar.'
  }, {
    question: '¿Es muy largo de leer?',
    answer: 'Está diseñado para padres ocupados: directo al grano y con acciones inmediatas.'
  }, {
    question: '¿Qué pasa si el problema es en la escuela?',
    answer: 'Incluimos una sección sobre cómo manejar la presión en los pasillos y lockers.'
  }];
  return <section ref={ref} className="w-full bg-darker-navy py-16 md:py-20 px-6" data-id="element-13">
      <div className="max-w-4xl mx-auto" data-id="element-14">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.6
      }} data-id="element-15">
          <div className="flex items-center gap-3 mb-12 justify-center" data-id="element-16">
            <HelpCircleIcon className="w-8 h-8 text-cyan" data-id="element-17" />
            <h2 className="text-4xl md:text-5xl font-oswald text-gold" data-id="element-18">
              Preguntas Frecuentes
            </h2>
          </div>

          <div className="space-y-6" data-id="element-19">
            {faqs.map((faq, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {
            opacity: 0,
            y: 20
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-dark-navy p-6 rounded-lg border border-cyan/20" data-id="element-20">
                <h3 className="text-xl font-bold text-white mb-3" data-id="element-21">
                  {faq.question}
                </h3>
                <p className="text-gray-400 leading-relaxed" data-id="element-22">{faq.answer}</p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}